export enum StagedUploadTargetGenerateUploadResource {
  CollectionImage = "COLLECTION_IMAGE",
  Image = "IMAGE",
  Model_3D = "MODEL_3D",
  ProductImage = "PRODUCT_IMAGE",
  ShopImage = "SHOP_IMAGE",
  Timeline = "TIMELINE",
  Video = "VIDEO",
}